import { isGuideSupported } from "@expert/solve-tools";

interface OpenOnCallStartProps {
    disableAutomaticOpen: boolean;
    isCustomerSession: boolean;
    isGuideOpen: boolean;
    isLoadingSimplrSession: boolean;
}
export function shouldOpenOnCallStart({
    disableAutomaticOpen,
    isCustomerSession,
    isGuideOpen,
    isLoadingSimplrSession,
}: Readonly<OpenOnCallStartProps>) {
    const isADTGuideAvailable = isGuideSupported("ADT Guide");

    return isADTGuideAvailable && !isGuideOpen && isCustomerSession && !disableAutomaticOpen && !isLoadingSimplrSession;
}
